import { render, staticRenderFns } from "./ProfileUpdateForm.vue?vue&type=template&id=508211bc&scoped=true"
import script from "./ProfileUpdateForm.vue?vue&type=script&lang=ts"
export * from "./ProfileUpdateForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileUpdateForm.vue?vue&type=style&index=0&id=508211bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508211bc",
  null
  
)

export default component.exports